export type ArticlePricingDetails = {
  averagePurchasePriceWithoutVat: number;
  averagePurchasePriceWithVat: number;
  lastPurchasePriceWithoutVat: number;
  lastPurchasePriceWithVat: number;
  recommendedPriceWithoutVat: number;
  recommendedPriceWithVat: number;
  saleBasePriceWithoutVat: number;
  saleBasePriceWithVat: number;
  warrantyPriceWithoutVat: number;
  warrantyPriceWithVat: number;
};
